import { Component } from '@angular/core';

@Component({
  selector: 'employee-grid-line',
  standalone: true,
  imports: [],
  templateUrl: './grid-line.component.html',
  styleUrl: './grid-line.component.less'
})
export class GridLineComponent {

}
